import Typography from "@mui/material/Typography";
import Box from "@mui/system/Box";
import styled from "styled-components";

export const Container = styled(Box)`
  height: 100svh;
  width: 100%;
  display: flex;
  align-items: center;
`;

export const Content = styled(Box)`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 24px;
`;

export const Title = styled(Typography)`
  font-family: "Outfit-SemiBold";
  font-size: 30px;
  font-weight: 600;
  line-height: 36px;
  letter-spacing: 0em;
  text-align: center;
`;

export const SubTitle = styled(Typography)`
  font-family: "NotoSans-Medium";
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
`;

export const LogoWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

export const TitleWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding-bottom: 32px;
`;

export const Wrapper = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 47px;
  ${(props) => props.theme.breakpoints.up("mobile")} {
    width: 50%;
  }
`;
